import { Injectable } from '@angular/core';
import { TokenAuthService } from './token-auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(public tokenAuthService: TokenAuthService,
    private httpClient: HttpClient,
  ) { }


  readonly rolesUrl = `${environment.base_URL}${environment.roles_URL}`;
  getRoles(): Observable<any> {
        const url = `${this.rolesUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  submitRoleForApproval(roleDto: any): Observable<any> {
    const url = `${this.rolesUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any[]>(url, roleDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  getRolePendingApprovals(): Observable<any> {
    const url = `${this.rolesUrl}/pending`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  viewRoleById(roleId: any): Observable<any> {
    const url = `${this.rolesUrl}/pending/${roleId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

   approveRole(roleId: any): Observable<any> {
    const url = `${this.rolesUrl}/approve/${roleId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  rejectRole(roleId: any): Observable<any> {
    const url = `${this.rolesUrl}/reject/${roleId}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  updateRole(roleId: any, roleDto: any): Observable<any> {
    const url = `${this.rolesUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, roleDto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  deleteRole(id: any): Observable<any> {
    const url = `${this.rolesUrl}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.delete<any>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }


    createRole(roleDto:any): Observable<any> {
    const url = `${this.rolesUrl}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, roleDto, { headers });
      }),
      catchError((error) => {
        console.error('Error creating Roles:', error);
        throw error;
      })
    );
  }


  getRoleById(id:any): Observable<any> {
    const url = `${this.rolesUrl}/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Roles:', error);
        throw error;
      })
    );
  }
   

    getPendingApprovalsComaprisonById(name:any): Observable<any> { 
     const url = `${this.rolesUrl}/pending/${name}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        console.error('Error fetching Roles:', error);
        throw error;
      })
    );
  
  }

  rejectRoleApprovalRequest(id:any): Observable<any> {
    const url = `${this.rolesUrl}/reject/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  
  
  }

    approveRoleApprovalRequest(id:any): Observable<any> {
    const url = `${this.rolesUrl}/approve/${id}`;

    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });

        return this.httpClient.post<any>(url, {}, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  
  
  }

  getRolesData(): Observable<any> {
    const url = `${this.rolesUrl}/get-role-data`;
    // Retrieve the token from the tokenAuthService
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

    getRolesByBusinessUnitId(businessUnitId: number): Observable<any> {
    const url = `${this.rolesUrl}/by-business-unit/${businessUnitId}`;
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
        return this.httpClient.get<any[]>(url, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  submitBURoleAllocations(dto: any): Observable<any> {
    const url = `${this.rolesUrl}/submit-for-approval`;
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`
        });
        return this.httpClient.post<any>(url, dto, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  approveAllRoles(ids: number[]): Observable<any> {
    const url = `${this.rolesUrl}/approve-all`;
    return this.tokenAuthService.getToken().pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`
        });
        return this.httpClient.post<any>(url, ids, { headers });
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

}
